<script lang="ts">
    import { _ } from "svelte-i18n"

    import { contentOverlay, iframeView, showOfferAssistant } from "../../../../store"
    import { apiBaseURL, OfferAssistantFTPAssetsUrl } from "../../../../config"

    import OfferAssistant from "./OfferAssistant.svelte"
    import ProductInquiry from "../../../product/ProductInquiry.svelte"

    let offerAssistantReset: boolean = false

    $showOfferAssistant = true

    const completeOfferAssistantInquiry = (e: CustomEvent) => {
        $contentOverlay = {
            component: ProductInquiry,
            props: {
                offerAssistantConfiguration: e.detail,
                submitInquirySuccessCallback,
            },
        }
    }

    const submitInquirySuccessCallback = () => {
        offerAssistantReset = true
    }
</script>

<div id="offerAssistantPage">
    {#if !$iframeView}
        <div class="headline">
            <div class="headline-container">
                <h1>
                    {#if $showOfferAssistant}
                        {$_("offer-assistant.title")}
                    {:else}
                        {$_("product-config.configurator")}
                    {/if}
                </h1>
            </div>
        </div>
    {/if}

    {#if $showOfferAssistant}
        <div class="offerAssistantContainer" class:iframe="{$iframeView}" class:site="{!$iframeView}">
            <OfferAssistant
                id="mailboxes"
                configUrl="{apiBaseURL}"
                ftpAssetsUrl="{OfferAssistantFTPAssetsUrl}"
                bind:reset="{offerAssistantReset}"
                bind:show="{$showOfferAssistant}"
                on:complete-inquiry="{completeOfferAssistantInquiry}"
            />
        </div>
    {/if}
</div>

<style lang="less">
    @import "../../../../css/variables.less";

    #offerAssistantPage {
        background-color: var(--surface);
        color: var(--on-surface);

        .headline {
            padding: 0px 40px;
            border-bottom: 1px solid var(--border-color-default);
            .flex();
            justify-content: space-between;
            align-items: stretch;
            position: relative;

            @media (max-width: 1300px) {
                padding: 0px 20px;
            }

            .headline-container {
                display: flex;
            }

            h1 {
                .flex();
                align-items: center;
                justify-content: center;
                margin: 0px;
                font-size: 1.5rem;
                padding: 15px 0px;
            }
        }

        .site.offerAssistantContainer {
            padding: 40px;
            @media (max-width: 1300px) {
                padding: 20px;
            }
            @media (max-width: 768px) {
                padding: 0px;
            }
        }
    }
</style>
